import { useMemo, useState } from "react";
import StitchPreview from "../../StitchEditor/StitchPreview";

// Separation precedes digitizing: use the editor's default fill at 100 mm.
const PREVIEW_STATE = { hoopSettings: { targetWidth: 100 } };

function Preview({ source, style }) {
  const [ready, setReady] = useState(false);
  return (
    <div style={{ display: "grid", width: "100%", ...style }}>
      <img
        src={source}
        alt="Thread color preview"
        style={{ gridArea: "1 / 1", width: "100%", height: "auto", maxHeight: "100%", objectFit: "contain", visibility: ready ? "hidden" : "visible" }}
      />
      <StitchPreview
        svgUrl={source}
        stitchState={PREVIEW_STATE}
        onReady={() => setReady(true)}
        style={{ gridArea: "1 / 1", width: "100%", height: "100%", minHeight: 0, alignSelf: "center" }}
      />
    </div>
  );
}

export default function ThreadSeparationPreview({ svgRaw, svgPreview, style }) {
  const source = useMemo(() => svgRaw
    ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgRaw)}`
    : svgPreview, [svgRaw, svgPreview]);
  // Reset both the renderer and fallback whenever the artwork/colors change.
  return source ? <Preview key={source} source={source} style={style} /> : null;
}
